import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import "./targeting-areas-list.styles.scss";

const targetingAreaPropType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  radius: PropTypes.number
});

const propTypes = {
  targetingAreas: PropTypes.arrayOf(targetingAreaPropType).isRequired
};

const TargetingArea = ({ area }) => (
  <div>
    <div className="font-weight-bold">{area.name}</div>
    {area.radius && <div className="font-size-small text-muted">{area.radius} mile radius</div>}
  </div>
);

TargetingArea.propTypes = { area: targetingAreaPropType.isRequired };

const TargetingAreasList = ({ targetingAreas }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [firstArea, ...remainingAreas] = targetingAreas;

  return (
    <div className="d-flex flex-column flex-md-row align-items-start">
      <div className="mb-2 mb-md-1 mr-md-2">
        <TargetingArea area={firstArea} />
      </div>
      {remainingAreas.length > 0 && (
        <Dropdown
          isOpen={isOpen}
          toggle={() => setIsOpen(!isOpen)}
          onMouseEnter={() => setIsOpen(true)}
          onMouseLeave={() => setIsOpen(false)}
          className="targeting-areas-dropdown"
          modifiers={{
            preventOverflow: { boundariesElement: "viewport" },
            flip: { enabled: true }
          }}
        >
          <DropdownToggle
            outline
            color="secondary"
            size="sm"
            className="btn-sharp rounded-pill py-0 px-2 d-flex align-items-center"
          >
            +{remainingAreas.length} more
            <i className={`fa fa-chevron-${isOpen ? "up" : "down"} ml-1`} />
          </DropdownToggle>
          <DropdownMenu
            className="targeting-areas-dropdown-menu overflow-auto"
            style={{ maxHeight: "200px", maxWidth: "90vw" }}
          >
            {remainingAreas.map(area => (
              <DropdownItem key={area.name} toggle={false} className="cursor-default text-wrap">
                <TargetingArea area={area} />
              </DropdownItem>
            ))}
          </DropdownMenu>
        </Dropdown>
      )}
    </div>
  );
};

TargetingAreasList.propTypes = propTypes;

export default TargetingAreasList;
